// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar {\n\twidth: 100%;\n\tbox-shadow: 0px 0px 5px #ebebeb/*#83A4CE*/;\n\tz-index: 3;\n}\n\n.navbar-container {\n\tmax-width: 1200px;\n\twidth: auto;\n\tmargin: auto;\n\tdisplay: flex;\n\tjustify-content: space-evenly;\n\tflex-wrap: wrap;\n}\n\n.navbar-link {\n\tpadding: 10px;\n\ttext-decoration: none;\n\tcolor: black;\n}\n\n.navbar-link:hover {\n\ttext-decoration: underline;\n}\n\n.navbar-link#selected {\n\tcolor: #83A4CE;\n\tfont-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
